import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

type Props = {
    loading: boolean
}

export class Loadable extends React.Component<Props> {
    render() {
        const { loading, children } = this.props;
        return loading
            ? (<div className={"loaders"}>
                    <LinearProgress/>
                    <LinearProgress color = "secondary"/>
                </div>)
            : children;
    }
}